import Service from '../service';

export default class Modal {
    public isshow: boolean = false;
    public callback: any = null;
    public cancel: any = async () => { };
    public hide: any = async () => { };
    public action: any = async () => { };
    public default_opts: any = {
        title: '확인이 필요합니다',
        message: '계속 진행하시겠습니까?',
        action: '확인',
        actionBtn: 'warning',
        cancel: '취소',
        status: 'warning'
    };
    public opts: any = {};

    constructor(private service: Service) { }

    public async show(mopts: any = {}) {
        this.isshow = true;
        this.opts = JSON.parse(JSON.stringify(this.default_opts));
        for (let key in mopts)
            this.opts[key] = mopts[key];

        const result = new Promise((resolve) => {
            this.cancel = async () => {
                this.isshow = false;
                await this.service.render();
                resolve(false);
            };

            this.hide = async () => {
                this.isshow = false;
                await this.service.render();
                resolve(false);
            };

            this.action = async (data: any = true) => {
                this.isshow = false;
                await this.service.render();
                resolve(data);
            };
        });

        await this.service.render();
        return await result;
    }

    public async error(message: string, cancel: any = false, action: string = '확인') {
        return await this.show({
            title: '',
            message,
            cancel,
            actionBtn: 'error',
            action,
            status: 'error'
        });
    }

    public async success(message: string, cancel: any = false, action: string = '확인') {
        return await this.show({
            title: '',
            message,
            cancel,
            actionBtn: 'success',
            action,
            status: 'success'
        });
    }

    public async warning(message: string, cancel: any = false, action: string = '확인') {
        return await this.show({
            title: '',
            message,
            cancel,
            actionBtn: 'warning',
            action,
            status: 'warning'
        });
    }

    public async localize(data: any = {}) {
        for (let key in data)
            if (this.default_opts[key])
                this.default_opts[key] = data[key];
    }
}
